<template lang="pug">
  .container
    .columns
      .column.is-3
        .field
          label.label Nombre
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Nombre',
                v-model="proveedor.nombre",
                :disabled="isDisabled"
              )
      .column.is-2
        .field
          label.label RFC
            .control
              input.input.is-primary(
                type='text', 
                placeholder='RFC',
                v-model="proveedor.rfc",
                :disabled="isDisabled"
              )
      .column.is-2
        .field
          label.label Teléfono 1
            .control
              input.input.is-primary(
                type='text', 
                placeholder='01-12345678',
                v-model="proveedor.telefono1",
                :disabled="isDisabled"
              )
      .column.is-1
        .field
          label.label Ext.
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Ext.',
                v-model="proveedor.ext",
                :disabled="isDisabled"
              )
      .column.is-2
        .field
          label.label Teléfono 2
            .control
              input.input.is-primary(
                type='text', 
                placeholder='01-12345678',
                v-model="proveedor.telefono2",
                :disabled="isDisabled"
              )
      .column.is-2
        .field
          label.label Teléfono 3
            .control
              input.input.is-primary(
                type='text', 
                placeholder='01-12345678',
                v-model="proveedor.telefono3",
                :disabled="isDisabled"
              )
    .columns.is-vcentered
      .column.is-2
        .field
          input#isNac.is-checkradio(type='checkbox' v-model='proveedor.isNacional' :disabled="isDisabled")
          label.is-size-6(for='isNac') Nacional
      .column.is-2
        .field
          label.label País
            .control
              input.input.is-primary(
                type='text', 
                placeholder='México',
                v-model="proveedor.pais",
                :disabled="isDisabled"
              )
      .column.is-2(v-show="this.proveedor.isNacional")
        label.label Estado:
          .control
            .select.is-primary.is-rounded
              select(v-model="proveedor.estadoSel" :disabled="isDisabled")
                option(v-for="est in estados" :key="est.id" :value="est.nombre") {{ est.nombre }}
      .column.is-2(v-show="!this.proveedor.isNacional")
        .field
          label.label Estado:
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Estado',
                v-model="proveedor.estadoSel",
                :disabled="isDisabled"
              )
      .column.is-2(v-show="this.proveedor.isNacional")
        .field
          .control
            Typeahead(:options="municipiosSel" :optionSelect="ciudadSelected" v-model="ciudadSelected" :isDisabled="isDisabled")
      .column.is-2(v-show="!this.proveedor.isNacional")
        .field
          label.label Ciudad:
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Ciudad',
                v-model="proveedor.ciudad",
                :disabled="isDisabled"
              )
      .column.is-2
        .field
          label.label Colonia:
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Colonia',
                v-model="proveedor.colonia",
                :disabled="isDisabled"
              )
      .column.is-2
        .field
          label.label Calle:
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Av...',
                v-model="proveedor.calle",
                :disabled="isDisabled"
              )
    .columns.is-vcentered
      .column.is-1
        .field
          label.label Núm. Ext.
            .control
              input.input.is-primary(
                type='text', 
                placeholder='#1',
                v-model="proveedor.numExt",
                :disabled="isDisabled"
              )
      .column.is-1
        .field
          label.label Núm. Int.
            .control
              input.input.is-primary(
                type='text', 
                placeholder='#1',
                v-model="proveedor.numInt",
                :disabled="isDisabled"
              )
      .column.is-2
        .field
          label.label C.P.
            .control
              input.input.is-primary(
                type='text', 
                placeholder='00000',
                v-model="proveedor.cp",
                :disabled="isDisabled"
              )
      .column.is-2
        label.label Crédito:
          .control
            .select.is-primary.is-rounded
              select(v-model="proveedor.credito" :disabled="isDisabled")
                option(value="SI") SI
                option(value="15 días") 15 días
                option(value="30 días") 30 días
                option(value="NO") NO
          
      .column.is-3
        .field
          label.label E-mail
            .control
              input.input.is-primary(
                type='text', 
                placeholder='correo@empresa.com',
                v-model="proveedor.email",
                :disabled="isDisabled"
              )
      .column.is-3
        .field
          label.label Contacto
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Nombre Contacto',
                v-model="proveedor.contacto",
                :disabled="isDisabled"
              )
    .columns
      .column.is-3
        label.label Banco:
          .control
            .select.is-primary.is-rounded
              select(v-model="bancoSel" :disabled="isDisabled")
                option(value="0") Pago en Efectivo
                option(v-for="bank in bancos" :key="bank.id" :value="bank") {{ bank.nombre }}
      .column.is-3(v-show="!pagoEfectivo")
        .field
          label.label Cuenta
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Num. Cuenta',
                v-model="proveedor.cuenta",
                :disabled="isDisabled"
              )
      .column.is-3(v-show="!pagoEfectivo")
        .field
          label.label Clabe Interbancaria
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Clabe Interbancaria',
                v-model="proveedor.clabe",
                :disabled="isDisabled"
              )
    .columns(v-show="datosFaltantes.length > 0")
      .column.is-12
        .notification
          button.delete(@click="closeNotification")
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
    .columns
      .column.is-3(v-show="estadoForm == 0")
        a.button.is-black.is-rounded.is-block(@click="changeStatusForm(0)")
          | Guardar
      .column.is-3(v-show="estadoForm == 1")
        a.button.is-warning.is-rounded.is-block(@click="changeStatusForm(1)")
          | Editar
      .column.is-3(v-show="estadoForm == 2")
        a.button.is-info.is-rounded.is-block(@click="changeStatusForm(2)")
          | Actualizar
      .column.is-3(v-show="estadoForm == 2")
        a.button.is-dark.is-rounded.is-block(@click="changeStatusForm(3)")
          | Cancelar
    .columns.column-blanco
</template>

<script>
  import Typeahead from './TypeaheadProveedor.vue'

  export default {
    name: 'Form_Proveedor',
    components: { Typeahead },
    props: {
      bancos: {
        type: Array,
        default: []
      },
      municipios: {
        type: Array,
        default: []
      },
      proveedor_edit: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        isDisabled: false,
        estados: [
          { id: 1, nombre: 'Aguascalientes'},
          { id: 2, nombre: 'Baja California'},
          { id: 3, nombre: 'Baja California Sur'},
          { id: 4, nombre: 'Campeche'},
          { id: 5, nombre: 'Chiapas'},
          { id: 6, nombre: 'Chihuahua'},
          { id: 7, nombre: 'Coahuila'},
          { id: 8, nombre: 'Colima'},
          { id: 9, nombre: 'Durango'},
          { id: 10, nombre: 'Estado de México'},
          { id: 11, nombre: 'Guanajuato'},
          { id: 12, nombre: 'Guerrero'},
          { id: 13, nombre: 'Hidalgo'},
          { id: 14, nombre: 'Jalisco'},
          { id: 15, nombre: 'Michoacán'},
          { id: 16, nombre: 'Morelos'},
          { id: 17, nombre: 'Nayarit'},
          { id: 18, nombre: 'Nuevo León'},
          { id: 19, nombre: 'Oaxaca'},
          { id: 20, nombre: 'Puebla'},
          { id: 21, nombre: 'Querétaro'},
          { id: 22, nombre: 'Quintana Roo'},
          { id: 23, nombre: 'San Luis Potosí'},
          { id: 24, nombre: 'Sinaloa'},
          { id: 25, nombre: 'Sonora'},
          { id: 26, nombre: 'Tabasco'},
          { id: 27, nombre: 'Tamaulipas'},
          { id: 28, nombre: 'Tlaxcala'},
          { id: 29, nombre: 'Veracruz'},
          { id: 30, nombre: 'Yucatán'},
          { id: 31, nombre: 'Zacatecas'},
          { id: 32, nombre: 'CDMX'},
        ],
        bancoSel: {},
        proveedor: {
          nombre: null,
          rfc: null,
          telefono1: null,
          ext: null,
          telefono2: null,
          telefono3: null,
          pais: 'México',
          estadoSel: null,
          ciudad: null,
          colonia: null,
          isNacional: true,
          colonia: null,
          calle: null,
          numExt: null,
          numInt: null,
          cp: null,
          contacto: null,
          email: null,
          credito: null,
          cuenta: null,
          clabe: null,
          idBanco: 0
        },
        datosFaltantes: [],
        municipiosSel: [],
        estadoForm: 0,
        ciudadSelected: {},
        pagoEfectivo: false
      }
    },
    watch: {
      'proveedor.isNacional'() {
        if (this.proveedor.isNacional) {
          this.proveedor.pais = 'México'
          if (this.estadoForm === 0) {
            this.proveedor.estadoSel = ''
          }
        } else {
          this.proveedor.estadoSel = ''
          this.proveedor.pais = ''
        }
      },
      bancoSel() {
        if (Object.keys(this.bancoSel).length > 0) {
          if (this.bancoSel === '0') {
            this.proveedor.efectivo = 1
            this.pagoEfectivo = true
            this.proveedor.idBanco = 0
            this.proveedor.clabe = ''
            this.proveedor.cuenta = ''
          } else {
            this.proveedor.idBanco = this.bancoSel.id
            this.pagoEfectivo = false
            this.proveedor.efectivo = 0
          }
          
        }
      },
      estadoForm() {
        switch (this.estadoForm) {
          case 0:
            this.isDisabled = false
            break
          case 1:
            this.isDisabled = true
            break
          case 2:
            this.isDisabled = false
            break
        
          default:
            this.isDisabled = false
            break
        }
      },
      'proveedor.estadoSel'() {
        if (!this.proveedor.estadoSel) {
          return
        }
        this.municipiosSel = []
        let results = this.municipios.filter( m => m.estado === this.proveedor.estadoSel)
        console.log(results)
        this.municipiosSel = results.map(this.convertirCiudades)
      },
      proveedor_edit() {
        if (Object.keys(this.proveedor_edit).length > 0 && this.municipios.length > 0) {
          this.checkProveedorEdit()
        }
      },
      ciudadSelected () {
        if (Object.keys(this.proveedor_edit).length > 0 && this.municipios.length > 0) {
          this.proveedor.ciudad = this.ciudadSelected.nombre
        }
      },
      municipios() {
        if (this.proveedor_edit && this.municipios.length > 0) {
          this.checkProveedorEdit()
        }
      }
    },
    methods: {
      iniciarComponente() {
        this.cleanForm()
        this.estadoForm = 0
      },
      checkProveedorEdit() {
        this.rellenarData()
        this.estadoForm = 1
      },
      changeStatusForm(estActual) {
        
        switch (estActual) {
          case 0:
            this.estadoForm = 0
            this.checkForm()
            break
          case 1:
            this.estadoForm = 2
            break
          case 2:
            this.estadoForm = 1
            this.checkForm()
            break
          case 3:
            this.estadoForm = 1
            break
          default:
            break
        }
      },
      checkForm() {
        if (this.proveedor.nombre && this.proveedor.rfc && this.proveedor.pais !== '' && this.proveedor.estadoSel) {
          console.log('Completo')
          if (this.estadoForm == 0) {
            this.guardarForm()
          } else {
            this.updateForm()
          }
        } else {
          console.log('Incompleto')
          if (!this.proveedor.nombre ) {
            this.datosFaltantes.push('El nombre es requerido.')
          }
          if (!this.proveedor.rfc) {
            this.datosFaltantes.push('El rfc es requerido.')
          }
          if (this.proveedor.pais === '') {
            this.datosFaltantes.push('El país es requerido.')
          }
          if (!this.proveedor.estadoSel) {
            this.datosFaltantes.push('El estado es requerido.')
          }
        }
      },
      guardarForm() {
        const nombre = this.proveedor.nombre
        const rfc = this.proveedor.rfc
        const pais = this.proveedor.pais
        const estadoSel = this.proveedor.estadoSel
        const isNacional = this.proveedor.isNacional
        const calle = this.proveedor.calle ? this.proveedor.calle : ''
        const ciudad = this.proveedor.ciudad ? this.proveedor.ciudad : ''
        const clabe = this.proveedor.clabe ? this.proveedor.clabe : ''
        const colonia = this.proveedor.colonia ? this.proveedor.colonia : ''
        const contacto = this.proveedor.contacto ? this.proveedor.contacto : ''
        const cp = this.proveedor.cp ? this.proveedor.cp : 0
        const credito = this.proveedor.credito ? this.proveedor.credito : 0
        const cuenta = this.proveedor.cuenta ? this.proveedor.cuenta : ''
        const email = this.proveedor.email ? this.proveedor.email : ''
        const ext = this.proveedor.ext ? this.proveedor.ext : 0
        const idBanco = this.proveedor.idBanco ? this.proveedor.idBanco : 0
        const numExt = this.proveedor.numExt ? this.proveedor.numExt : 0
        const numInt = this.proveedor.numInt ? this.proveedor.numInt : ''
        const telefono1 = this.proveedor.telefono1 ? this.proveedor.telefono1 : '' 
        const telefono2 = this.proveedor.telefono2 ? this.proveedor.telefono2 : ''
        const telefono3 = this.proveedor.telefono3 ? this.proveedor.telefono3 : ''
        const efectivo = this.proveedor.efectivo ? this.proveedor.efectivo : 0
        const proveedorForm = {
          nombre,
          rfc,
          pais,
          estadoSel,
          calle,
          ciudad,
          clabe,
          colonia,
          contacto,
          cp,
          credito,
          cuenta,
          email,
          ext,
          idBanco,
          numExt,
          numInt,
          telefono1,
          telefono2,
          telefono3,
          efectivo,
          isNacional,
        }
        this.$emit('saveForm', proveedorForm)
        this.estadoForm = 1
      },
      updateForm() {
        const nombre = this.proveedor.nombre
        const rfc = this.proveedor.rfc
        const pais = this.proveedor.pais
        const estadoSel = this.proveedor.estadoSel
        const isNacional = this.proveedor.isNacional
        const calle = this.proveedor.calle ? this.proveedor.calle : ''
        const ciudad = this.proveedor.ciudad ? this.proveedor.ciudad : ''
        const clabe = this.proveedor.clabe ? this.proveedor.clabe : ''
        const colonia = this.proveedor.colonia ? this.proveedor.colonia : ''
        const contacto = this.proveedor.contacto ? this.proveedor.contacto : ''
        const cp = this.proveedor.cp ? this.proveedor.cp : 0
        const credito = this.proveedor.credito ? this.proveedor.credito : 0
        const cuenta = this.proveedor.cuenta ? this.proveedor.cuenta : ''
        const email = this.proveedor.email ? this.proveedor.email : ''
        const ext = this.proveedor.ext ? this.proveedor.ext : 0
        const idBanco = this.proveedor.idBanco ? this.proveedor.idBanco : 0
        const numExt = this.proveedor.numExt ? this.proveedor.numExt : 0
        const numInt = this.proveedor.numInt ? this.proveedor.numInt : ''
        const telefono1 = this.proveedor.telefono1 ? this.proveedor.telefono1 : '' 
        const telefono2 = this.proveedor.telefono2 ? this.proveedor.telefono2 : ''
        const telefono3 = this.proveedor.telefono3 ? this.proveedor.telefono3 : ''
        const efectivo = this.proveedor.efectivo ? this.proveedor.efectivo : 0
        const proveedorForm = {
          nombre,
          rfc,
          pais,
          estadoSel,
          calle,
          ciudad,
          clabe,
          colonia,
          contacto,
          cp,
          credito,
          cuenta,
          email,
          ext,
          idBanco,
          numExt,
          numInt,
          telefono1,
          telefono2,
          telefono3,
          efectivo,
          isNacional,
        }
        this.$emit('saveForm', proveedorForm)
        this.estadoForm = 1
      },
      closeNotification() {
        this.datosFaltantes = []
      },
      convertirCiudades(item) {
        return {
          ...item,
          nombre: item.municipio
        }
      },
      rellenarData  () {
        if (this.proveedor_edit) {
          this.proveedor.nombre = this.proveedor_edit.nombre
          this.proveedor.isNacional = this.proveedor_edit.isNacional
          this.proveedor.rfc = this.proveedor_edit.rfc
          this.proveedor.telefono1 = this.proveedor_edit.telefono1
          this.proveedor.ext = this.proveedor_edit.extTelefono1
          this.proveedor.telefono2 = this.proveedor_edit.telefono2
          this.proveedor.telefono3 = this.proveedor_edit.telefono3
          this.proveedor.pais = this.proveedor_edit.pais
          this.proveedor.colonia = this.proveedor_edit.colonia
          this.proveedor.colonia = this.proveedor_edit.colonia
          this.proveedor.calle = this.proveedor_edit.calle
          this.proveedor.numExt = this.proveedor_edit.numExt
          this.proveedor.numInt = this.proveedor_edit.numInt
          this.proveedor.cp = this.proveedor_edit.cp
          this.proveedor.contacto = this.proveedor_edit.contacto
          this.proveedor.email = this.proveedor_edit.correo
          this.proveedor.credito = this.proveedor_edit.credito
          this.proveedor.cuenta = this.proveedor_edit.cuenta
          this.proveedor.clabe = this.proveedor_edit.clabeInterbancaria
          this.bancoSel = this.bancos.find( b => b.id == this.proveedor_edit.idBanco) 
          const _estadoSel = this.estados.find( e => e.nombre === this.proveedor_edit.estado)
          console.log(_estadoSel)
          this.proveedor.estadoSel = _estadoSel.nombre
          setTimeout(() => {
            console.log(this.municipiosSel)
            if (this.municipiosSel) {
              const _ciudad = this.municipiosSel.find( m => m.municipio === this.proveedor_edit.ciudad)
              this.ciudadSelected = _ciudad
            }
          }, 500)
        }
      },
      cleanForm () {
          this.proveedor.nombre = null
          this.proveedor.rfc= null,
          this.proveedor.telefono1= null,
          this.proveedor.ext= null,
          this.proveedor.telefono2= null,
          this.proveedor.telefono3= null,
          this.proveedor.pais= 'México',
          this.proveedor.estadoSel= null,
          this.proveedor.ciudad= null,
          this.proveedor.colonia= null,
          this.proveedor.isNacional= true,
          this.proveedor.colonia= null,
          this.proveedor.calle= null,
          this.proveedor.numExt= null,
          this.proveedor.numInt= null,
          this.proveedor.cp= null,
          this.proveedor.contacto= null,
          this.proveedor.email= null,
          this.proveedor.credito= false,
          this.proveedor.cuenta= null,
          this.proveedor.clabe= null,
          this.proveedor.idBanco= 0
      }
    },
    mounted () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/FormProveedor.vue